export const SET_SELECTION_MENU = "SET_SELECTION_MENU";

export const SHOPEE_APP_CLICKED = "SHOPEE_APP_CLICKED";